import z from "zod";

import { api } from "~/api";
import { createServiceResponseSchema } from "../schemas";
import {
  StartBookingFlow,
  StoreSlotDateView,
  UpdateBookingFlow,
} from "./types";

const startBookingFlowResponseSchema = z.object({
  id: z.string(),
});

const updateBookingFlowResponseSchema = z.object({
  id: z.string(),
});

export const startBookingFlow = async (data: StartBookingFlow) => {
  const response = await api.post("/booking-flows", data);

  return createServiceResponseSchema(startBookingFlowResponseSchema).parse(
    response.data,
  ).data;
};

export const updateBookingFlow = async (data: UpdateBookingFlow) => {
  const response = await api.patch(`/booking-flows/${data.id}`, data);

  return createServiceResponseSchema(updateBookingFlowResponseSchema).parse(
    response.data,
  ).data;
};

export const storeSlotDateView = async ({
  id,
  slotDateViewed,
  providers,
}: StoreSlotDateView) => {
  await api.post(`/booking-flows/${id}/slot-date-views`, {
    slot_date_viewed: slotDateViewed,
    providers: providers.map((provider) => ({
      id: provider.id,
      slot_count: provider.slotCount,
    })),
  });
};
